//#region src/errors/unauthorized-response.ts
var e = class extends Error {
	redirect;
	constructor(e) {
		super(e), this.redirect = e;
	}
};
//#endregion
export { e as UnauthorizedResponse };
